import React from 'react';
import { Button } from '../../ui/Button';
import { Select } from '../../ui/Select';
interface BusinessTypeScreenProps {
  mccCode: string;
  companyType: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function BusinessTypeScreen({
  mccCode,
  companyType,
  onChange,
  onNext,
  onBack
}: BusinessTypeScreenProps) {
  const isValid = mccCode !== '' && companyType !== '';
  const mccOptions = [{
    value: '5812',
    label: 'Eating Places, Restaurants (5812)'
  }, {
    value: '5411',
    label: 'Grocery Stores, Supermarkets (5411)'
  }, {
    value: '5999',
    label: 'Miscellaneous Retail (5999)'
  }, {
    value: '7372',
    label: 'Computer Programming, Software (7372)'
  }, {
    value: '8011',
    label: 'Doctors, Physicians (8011)'
  }, {
    value: '5045',
    label: 'Computers, Computer Equipment (5045)'
  }, {
    value: '7311',
    label: 'Advertising Services (7311)'
  }, {
    value: '5734',
    label: 'Computer Software Stores (5734)'
  }];
  const typeOptions = [{
    value: 'llc',
    label: 'Limited Liability Company (LLC)'
  }, {
    value: 'corporation',
    label: 'Corporation (C-Corp / S-Corp)'
  }, {
    value: 'sole_proprietorship',
    label: 'Sole Proprietorship'
  }, {
    value: 'partnership',
    label: 'Partnership'
  }, {
    value: 'non_profit',
    label: 'Non-Profit Organization'
  }];
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-127">
      <div className="flex-1" data-id="element-128">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-129">
          Business Type
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-130">
          Select your industry code and company structure.
        </p>

        <div className="space-y-6" data-id="element-131">
          <Select label="MCC Code (Industry)" options={mccOptions} value={mccCode} onChange={e => onChange('mccCode', e.target.value)} data-id="element-132" />
          <Select label="Company Type" options={typeOptions} value={companyType} onChange={e => onChange('companyType', e.target.value)} data-id="element-133" />
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-134">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-135">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-136">
          Continue
        </Button>
      </div>
    </div>;
}